import { ReactNode } from "react";

export default function PauseSection({ children }: { children: ReactNode }) {
    return <div className="flex flex-col gap-3 py-2 border-r border-black pr-3 h-min">
        {children}
    </div>
}